import { call, put, takeLatest } from 'redux-saga/effects';

import { AuthenticationResult } from '@azure/msal-browser';
import { publicClientApplication as msalInstance } from '../../../../index';
import { RolesService, Role } from '../../../../entities/Roles';
import { getRoleError, getRoleSuccess, setAccount } from './actions';
import { GET_ACCOUNT, GET_ROLE_REQUEST, msalScopes } from './constants';
import history from '../../../../browserHistory';

const authSagaLog = (message: string, details?: unknown) => {
  const isDebugEnabled = process.env.NODE_ENV !== 'production' || localStorage.getItem('app_auth_debug') === '1';

  if (!isDebugEnabled) {
    return;
  }

  // eslint-disable-next-line no-console
  console.log(`[AUTH][saga] ${message}`, details ?? '');
};

function* getAccountSaga() {
  const account = msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
  authSagaLog('getAccountSaga started', { hasAccount: Boolean(account), username: account?.username });

  if (!account) {
    yield put(setAccount(null));
    authSagaLog('No account found, account reset to null');
    return;
  }

  try {
    const token: AuthenticationResult = yield msalInstance.acquireTokenSilent({
      // @ts-ignore
      scopes: msalScopes,
      account,
    });

    if (token.account) {
      msalInstance.setActiveAccount(token.account);
    }

    yield put(setAccount(token.account));
    authSagaLog('Account acquired successfully', { username: token.account?.username });
  } catch (error: any) {
    yield put(setAccount(null));
    authSagaLog('getAccountSaga failed', {
      errorCode: error?.errorCode || error?.subError,
      message: error?.message,
    });

    if (window.self === window.top) {
      history.push('/');
      authSagaLog('Redirected to / from getAccountSaga catch');
    }
  }
}

function* getRolesSaga() {
  authSagaLog('getRolesSaga started');
  try {
    const role: Role = yield call(RolesService.getRole);
    localStorage.setItem('role', JSON.stringify(role));

    const branches = role.branches.filter((br: any) => !br.isDeleted);
    const branchTitle = JSON.parse(localStorage.getItem('branchId') || 'null');

    if (!branchTitle && branches.length && role.id !== 5) {
      localStorage.setItem('branchId', JSON.stringify(branches[0]));
    }
    if (branchTitle && branches && branches.length) {
      const newBranch = branches.find((b) => b.id === branchTitle.id);
      localStorage.setItem('branchId', JSON.stringify(newBranch));
    }

    yield put(getRoleSuccess(role));
    authSagaLog('Role loaded successfully', { role: role.name, roleId: role.id });
  } catch (error: any) {
    yield put(getRoleError(error.errorExtraParams));
    authSagaLog('getRolesSaga failed', {
      message: error?.message,
      errorExtraParams: error?.errorExtraParams,
    });
    history.push('/role-undefined');
  }
}

export function* authSagaWatcher() {
  yield takeLatest(GET_ROLE_REQUEST, getRolesSaga);
  yield takeLatest(GET_ACCOUNT, getAccountSaga);
}
